/**
 * @generated SignedSource<<9e3839309022a42203f45123227e753d>>
 * @relayHash b0dd45232c55471ed84d256c7510183e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e5b8c2b4ac94740de0798cfbfed7937fdffc42698d741d17a3615c505a23fc2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_adminPagesPerformance_Overview_Query$variables = {
  cloudId: string;
};
export type main_adminPagesPerformance_Overview_Query$data = {
  readonly jira: {
    readonly resourceUsageMetrics: {
      readonly " $fragmentSpreads": FragmentRefs<"main_adminPagesPerformance_OverviewPage">;
    };
  };
};
export type main_adminPagesPerformance_Overview_Query = {
  response: main_adminPagesPerformance_Overview_Query$data;
  variables: main_adminPagesPerformance_Overview_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "main_adminPagesPerformance_Overview_Query",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraResourceUsageMetricConnection",
                "kind": "LinkedField",
                "name": "resourceUsageMetrics",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "main_adminPagesPerformance_OverviewPage"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.resourceUsageMetrics"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "main_adminPagesPerformance_Overview_Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraResourceUsageMetricConnection",
            "kind": "LinkedField",
            "name": "resourceUsageMetrics",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraResourceUsageMetric",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "currentValue"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "warningValue"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "thresholdValue"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9e5b8c2b4ac94740de0798cfbfed7937fdffc42698d741d17a3615c505a23fc2",
    "metadata": {},
    "name": "main_adminPagesPerformance_Overview_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "65285ab59e67a0f62edb54671f986ddd";

export default node;
